import { Children, forwardRef, useRef } from "react";
import { Button, ButtonBase, Checkbox, Dialog, InputAdornment, IconButton, Menu, MenuItem, OutlinedInput, Select } from "@mui/material";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import SearchRounded from "@mui/icons-material/SearchRounded";
import CheckRounded from "@mui/icons-material/CheckRounded";
import "./MonitorControls.css";

export const MonitorButton = forwardRef(function MonitorButton({ className = "", title, ...props }, ref) {
  const icon = /(?:iconbtn|refresh|modal-close|^x$|^zr(?: |$))/.test(className);
  const action = /(?:subtab|dtab|stab|kpi|auf-zelle)/.test(className);
  const Component = icon ? IconButton : action ? ButtonBase : Button;
  return <Component ref={ref} type="button" title={title} aria-label={icon ? title : undefined}
    className={`iio-monitor-button ${icon ? "iio-monitor-icon" : ""} ${className}`} {...props}/>;
});

export const MonitorInput = forwardRef(function MonitorInput({ className = "", "aria-label": label, placeholder, maxLength, search, ...props }, ref) {
  return <OutlinedInput inputRef={ref} size="small" className={`iio-monitor-input ${className}`}
    placeholder={placeholder} startAdornment={search?<InputAdornment position="start"><SearchRounded/></InputAdornment>:undefined} inputProps={{ "aria-label": label || placeholder, maxLength }} {...props}/>;
});

export function MonitorCheckbox({ className = "", "aria-label": label, ...props }) {
  return <Checkbox className={`iio-monitor-checkbox ${className}`} inputProps={{ "aria-label": label }} {...props}/>;
}

export function MonitorSelect({ children, className = "", "aria-label": label, ...props }) {
  const input = useRef(null);
  return <Select displayEmpty size="small" inputRef={input} IconComponent={ExpandMoreRounded}
    className={`iio-monitor-select ${className}`} inputProps={{ "aria-label": label }}
    MenuProps={{ PaperProps: { className: "iio iio-monitor-menu" }, MenuListProps: { "aria-label": label },
      TransitionProps: { onExited: () => input.current?.focus() } }} {...props}>
    {Children.toArray(children).filter(option => option?.props).map(option => <MenuItem key={option.props.value}
      value={option.props.value} disabled={option.props.disabled}>
      <span className="iio-monitor-option-label">{option.props.children}</span>
      {props.value === option.props.value && <CheckRounded className="iio-monitor-option-check" aria-hidden="true"/>}
    </MenuItem>)}
  </Select>;
}

export function MonitorMenu({ children, ...props }) {
  return <Menu PaperProps={{ className: "iio iio-monitor-menu" }} TransitionProps={{ onExited: () => props.anchorEl?.focus?.() }} {...props}>{children}</Menu>;
}
export { MenuItem as MonitorMenuItem };

export function MonitorDialog({ children, className = "", ...props }) {
  return <Dialog open fullWidth maxWidth="md" PaperProps={{ className: `iio iio-monitor-dialog ${className}` }} {...props}>{children}</Dialog>;
}
